import React from 'react';
import { TrustBar } from './TrustBar';
import { Services } from './Services';
import { ProjectTypes } from './ProjectTypes';
import { Storefronts } from './Storefronts';
import { InteriorGlass } from './InteriorGlass';
import { ContractGlazing } from './ContractGlazing';
import { ProjectShowcase } from './ProjectShowcase';
import { Industries } from './Industries';
import { Process } from './Process';
import { WhyChoose } from './WhyChoose';
import { Locations } from './Locations';
import { CommercialGlassFAQ } from '../../components/CommercialGlassFAQ/CommercialGlassFAQ';
import { ServiceReview } from '../../../components/PageIntro';
export function CommercialGlass() {
  return <div className="legacy-sections" data-id="element-657" data-mp="1mhlf1kpdh0v6">
<TrustBar data-id="element-658" data-mp="1mhv8xjdjfs65" />
<Services data-id="element-659" data-mp="1mgk0h695dw8p" />
<ServiceReview index={1} data-id="element-660" data-mp="1mh39tykqfcb4" />
<ProjectTypes data-id="element-661" data-mp="1mfio8ygeb3pe" />
<Storefronts data-id="element-662" data-mp="3j9veio7g70iq" />
<InteriorGlass data-id="element-663" data-mp="3jaeuhzdjfeu4" />
<ContractGlazing data-id="element-664" data-mp="3jax0hnq057f8" />
<ProjectShowcase data-id="element-665" data-mp="3jbg748a7c9dy" />
<Industries data-id="element-666" data-mp="3jbycbueudxy0" />
<Process data-id="element-667" data-mp="3jc851pr9uj7e" />
<WhyChoose data-id="element-668" data-mp="3o8ykqbz5zcsa" />
<Locations data-id="element-669" data-mp="3o8gd6j71xc52" />
<CommercialGlassFAQ data-id="element-670" data-mp="3o86nyxttz90f" />
</div>;
}